/* eslint-disable func-names */
import {
  CREATE_INSPECTION, FETCH_INSPECTION_LIST, FETCH_INSPECTION, CLEAR_INSPECTION,
  CREATE_INSPECTION_ANSWER,
  FETCH_INSPECTION_ANSWER_LIST,
  FETCH_INSPECTION_ANSWER,
  FETCH_CHECKLIST_ATTACHMENTS,
  CLEAR_INSPECTION_ANSWER,
  CLEAR_ACTION_RESULT,
  FETCH_INSPECTION_FOR_EDIT,
  SEARCH_USER,
  CREATE_REMARK,
  FETCH_SAFETY_SELF_INSPECTION,
  FETCH_TEMPLATES,
  FETCH_TEMPLATE,
  EXPORT_INSPECTION,
  EXPORT_INSPECTION_DATA,
  FETCH_SUMMARY,
  CREATE_DRAFT_INSPECTION_ANSWER,
  FETCH_DRAFT_INSPECTION,
  CLEAR_OPEN_WORKORDERS,
  FETCH_OPEN_WORKORDERS,
  FETCH_DATA_SOURCES,
  FETCH_DATA_SOURCE_VALUES,
  CLEAR_ACTION_DATA_SOURCE,
  FORM_ANSWERS_LIST,
  CLEAR_LOADING_ACTIONS,
  FORMS_PUBLISHED_LIST,
  PUBLISHED_FORM,
  CLEAR_REMARK,
  FETCH_SHIFT_TYPES,
  DELETE_REMARK,
  REMOVE_REMARK,
  HANGAR_INSPECTION_ANSWERS_LIST
} from './types';

import { actionForState } from '../../../utils/helpers';

const apiPayload = {
  success: false,
  loading: false,
  error: false
};

const INITIAL_STATE = {
  formAnswerListAction: {
    success: false,
    loading: false,
    error: false
  },
  inspection: {},
  selfInspection: {},
  createInspectionAction: {},
  fetchInspectionAction: {},
  publishedFormsList: [],
  formsAnswerList: [],
  getPublishedFormAction: apiPayload,
  inspectionList: { results: [] },
  answers: [],
  answer: {},
  userlist: [],
  draftAction: {
    success: false, pending: false, error: false
  },
  fetchDraftInspectionAction: {
    success: false, pending: false, error: false
  },
  fetchRemarksAction: {
    success: false,
    loading: false,
    error: false
  },
  inspection_list: {},
  fetchSumaryAction: {
    success: false, pending: false, error: false
  },
  hangarAnswerListAction: {
    success: false,
    loading: false,
    error: false
  }
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FORM_ANSWERS_LIST.pending:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'pending')
      };
    case FORM_ANSWERS_LIST.success: {
      return {
        ...state,
        formsAnswerList: action.payload,
        formAnswerListAction: actionForState(state.action, 'success')
      };
    }
    case FORM_ANSWERS_LIST.error:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'error')
      };

      case FETCH_SHIFT_TYPES.pending:
      return {
        ...state,
        actionFetchShiftTypes: actionForState(state.action, 'pending')
      };
    case FETCH_SHIFT_TYPES.success:
      return {
        ...state,
        shiftTypes: action.payload.results,
        actionFetchShiftTypes: actionForState(state.action, 'success')
      };
    case FETCH_SHIFT_TYPES.error:
      return {
        ...state,
        actionFetchShiftTypes: actionForState(state.action, 'error')
      };

      case CLEAR_LOADING_ACTIONS:
      return {
        ...state,
        formAnswerListAction: apiPayload,
        publishedFormData: {},
        hangarAnswerListAction: apiPayload
      };

      case FORMS_PUBLISHED_LIST.pending:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'pending')
      };
    case FORMS_PUBLISHED_LIST.success: {
      return {
        ...state,
        publishedFormsList: action.payload,
        formAnswerListAction: actionForState(state.action, 'success')
      };
    }
    case FORMS_PUBLISHED_LIST.error:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'error')
      };

      case PUBLISHED_FORM.pending:
      return {
        ...state,
        getPublishedFormAction: actionForState(state.action, 'pending')
      };
    case PUBLISHED_FORM.success: {
      let detailFields;
      let checklistFields;

      if (action.payload.template) {
        const { sections } = action.payload.template.schema;
        const templatedetailFields = sections[0].fields
          .map(f => action.payload.template.schema.fields.find(fi => fi.id === f))
          .map(f => ({ ...f, template: true }));

        const templatechecklistFields = sections[1].fields
          .map(f => action.payload.template.schema.fields.find(fi => fi.id === f))
          .map(f => ({ ...f, template: true }));

        let airportFields = action.payload.airport_changes.fields.filter(
          f => !f.hidden
        );
        airportFields = airportFields.map((f) => {
          if (sections[0].fields.includes(f.id)) {
            return templatedetailFields.find(tf => tf.id === f.id);
          }
          return f;
        });

        if (action.payload.airport_changes.fields.length > 0) {
          detailFields = airportFields.sort((a, b) => a.order < b.order);
        } else {
          detailFields = templatedetailFields;
        }

        let airportChecklist = action.payload.airport_changes.inspectionChecklist.filter(
          f => !f.hidden
        );
        airportChecklist = airportChecklist.map((f) => {
          if (sections[1].fields.includes(f.id)) {
            return templatechecklistFields.find(tf => tf.id === f.id);
          }
          return f;
        });

        if (action.payload.airport_changes.inspectionChecklist.length > 0) {
          checklistFields = airportChecklist.sort((a, b) => a.order < b.order);
        } else {
          checklistFields = templatechecklistFields;
        }
      } else {
        const { sections } = action.payload.form.schema;
        detailFields = sections[0].fields.map(f => action.payload.form.schema.fields.find(fi => fi.id === f));

        checklistFields = sections[1].fields.map(f => action.payload.form.schema.fields.find(fi => fi.id === f));
      }

      let groups = [];
      if (action.payload.form.schema?.groups) {
        const allGroupFields = [];
        action.payload.form.schema.groups.forEach((group) => {
          groups.push({
            id: group.id,
            title: group.title,
            fields: group.fields || []
          });
          allGroupFields.push(...group.fields);
        });
        const noGroupFields = checklistFields
          .filter(
            checklistField => allGroupFields.filter(field => field === checklistField.id)
              .length === 0
          )
          .map(Field => Field.id);
        if (noGroupFields.length > 0) {
          groups = groups.map(grp => (grp.id === 'GRP1'
            ? { ...grp, fields: [...grp.fields, ...noGroupFields] }
            : { ...grp }));
        }
      } else {
        const groupFields = checklistFields.map(field => field.id);
        groups.push({
          id: 'GRP1',
          title: 'Inspection Summary',
          fields: [...groupFields]
        });
      }
      let default_satisfactory = true;
      if (action.payload.settings && 'default_satisfactory' in action.payload.settings) {
        default_satisfactory = action.payload.settings?.default_satisfactory;
      }
      let template_footer = false;
      if (action.payload.settings && 'template_footer' in action.payload.settings) {
        template_footer = action.payload.settings?.template_footer;
      }
      let footer_description = '';
      if (action.payload.settings && 'footer_description' in action.payload.settings) {
        footer_description = action.payload.settings?.footer_description;
      }
      return {
        ...state,
        inspection: {
          id: action.payload.id,
          category: action.payload?.category,
          workorders: action.payload.open_workorders,
          template: action.payload.template,
          new_version_available: action.payload.new_version_available,
          version_id: action.payload.form.id,
          send_email: action.payload.send_email
            ? action.payload.send_email
            : undefined,
          inspection_assignee: action.payload.inspection_assignee
            ? action.payload.inspection_assignee
            : undefined,
          info: {
            title:
              action.type === FETCH_INSPECTION.success
                ? action.payload.title
                : action.payload.form.title,
            icon:
              action.type === FETCH_INSPECTION.success
                ? action.payload.icon
                : action.payload.form.icon
          },
          airport_changes: action.payload.airport_changes,
          task: action.payload.task,
          departments: action.payload.departments,
          multiple_tasks: action.payload.multiple_tasks,
          access_type: action.payload.access_type,
          form_access: action.payload.form_access,
          link_workorders: action.payload.link_workorders,
          global_locations: action.payload?.global_locations,
          supplement_inspection: action.payload.form?.supplement_inspection || false,
          workorder_satisfactory: action.payload.form?.version_settings?.workorder_satisfactory || false,
          tolerance_inspection: action.payload.form?.version_settings?.tolerance_inspection || false,
          remarks_carry_over: action.payload.form?.version_settings?.remarks_carry_over || false,
          attach_notams: action.payload.form?.version_settings?.attach_notams || false,
          settings: action.payload.form?.version_settings,
          default_satisfactory,
          template_footer,
          footer_description,
          connect_airfield_workorders:
            action.payload.connect_airfield_workorders,
          details: {
            fields: [...detailFields],
            additionalInfo: action.payload.additionalInfo
          },
          checklist: [...checklistFields],
          multipleColumn: action.payload.multiple_columns,
          columns: checklistFields[0].columns,
          groups,
          enable_inspection_review: action.payload.enable_review_inspection,
          ops_log: action.payload.ops_log,
          is_shared: action.payload.is_shared,
          schedule_type: action.payload.schedule_type,
          schedule_interval: action.payload.schedule_interval
        },
        getPublishedFormAction: actionForState(state.action, 'success')
      };
    }
    case PUBLISHED_FORM.error:
      return {
        ...state,
        getPublishedFormAction: actionForState(state.action, 'error')
      };

    case CREATE_INSPECTION.success:
      return {
        ...state,
        createInspectionAction: actionForState(action, 'success', 'success')
      };
    case CREATE_INSPECTION.error:
      return {
        ...state,
        createInspectionAction: actionForState(action.payload.response, 'failed')
      };
    case FETCH_INSPECTION.success:
    case FETCH_INSPECTION_FOR_EDIT.success: {
      let detailFields; let checklistFields;

      if (action.payload.template) {
        const { sections } = action.payload.template.schema;
        const templatedetailFields = sections[0].fields.map(
          f => action.payload.template.schema.fields.find(fi => fi.id === f)
        ).map(f => ({ ...f, template: true }));

        const templatechecklistFields = sections[1].fields.map(
          f => action.payload.template.schema.fields.find(fi => fi.id === f)
        ).map(f => ({ ...f, template: true }));

        let airportFields = action.payload.airport_changes.fields.filter(f => !f.hidden);
        airportFields = airportFields.map((f) => {
          if (sections[0].fields.includes(f.id)) {
            return templatedetailFields.find(tf => tf.id === f.id);
          }
          return f;
        });

        if (action.payload.airport_changes.fields.length > 0) {
          detailFields = airportFields.sort((a, b) => (a.order < b.order));
        } else {
          detailFields = templatedetailFields;
        }

        let airportChecklist = action.payload.airport_changes.inspectionChecklist.filter(f => !f.hidden);
        airportChecklist = airportChecklist.map((f) => {
          if (sections[1].fields.includes(f.id)) {
            return templatechecklistFields.find(tf => tf.id === f.id);
          }
          return f;
        });

        if (action.payload.airport_changes.inspectionChecklist.length > 0) {
          checklistFields = airportChecklist.sort((a, b) => (a.order < b.order));
        } else {
          checklistFields = templatechecklistFields;
        }
      } else {
        const { sections } = action.payload.form.schema;
        detailFields = sections[0].fields.map(
          f => action.payload.form.schema.fields.find(fi => fi.id === f)
        );

        checklistFields = sections[1].fields.map(
          f => action.payload.form.schema.fields.find(fi => fi.id === f)
        );
      }

      return {
        ...state,
        inspection: {
          id: action.payload.id,
          workorders: action.payload.open_workorders,
          template: action.payload.template,
          new_version_available: action.payload.new_version_available,
          version_id: action.payload.form.id,
          info: {
            title: action.type === FETCH_INSPECTION.success
              ? action.payload.title
              : action.payload.form.title,
            icon: action.type === FETCH_INSPECTION.success
              ? action.payload.icon
              : action.payload.form.icon
          },
          airport_changes: action.payload.airport_changes,
          task: action.payload.task,
          access_type: action.payload.access_type,
          form_access: action.payload.form_access,
          details: {
            fields: [...detailFields],
            additionalInfo: action.payload.additionalInfo
          },
          checklist: [...checklistFields]
        },
        fetchInspectionAction: actionForState(action, 'success', 'success')
      };
    }
    case EXPORT_INSPECTION.success: {
      const link = document.createElement('a');
      link.href = action.payload;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // eslint-disable-next-line no-fallthrough
    case EXPORT_INSPECTION_DATA.success: {
      const link = document.createElement('a');
      link.href = action.payload;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    // eslint-disable-next-line no-fallthrough
      case CLEAR_INSPECTION:
      return {
        ...state,
        inspection: {},
        templateList: [],
        template: undefined,
        createInspectionAction: {},
        deleteInspectionAction: {},
        fetchInspectionAction: {},
        createAction: {},
        draftdata: {},
        connectedWorkOrders: {},
        connectedAirfieldWorkOrders: {},
        answerCreated: {},
        inspectionList: {},
        inspectionTempList: { results: [] }
      };
      case CLEAR_REMARK:
      return {
        ...state,
        remarkCreated: {}
      };
    case FETCH_INSPECTION_LIST.pending:
      return {
        ...state,
        action: actionForState('loading')
      };
    case FETCH_INSPECTION_LIST.success:
      return {
        ...state,
        inspectionList: action.payload,
        action: actionForState(action, 'success', 'success')
      };
    case FETCH_INSPECTION_LIST.error:
      return {
        ...state,
        action: {
          ...state.action,
          success: false,
          loading: false,
          message: 'failed'
        }
      };

    case FETCH_SUMMARY.pending:
      return {
        ...state,
        action: actionForState('loading')
      };
    case FETCH_SUMMARY.success:
      return {
        ...state,
        summary: action.payload,
        action: actionForState(action, 'success', 'success')
      };
    case FETCH_SUMMARY.error:
      return {
        ...state,
        action: {
          ...state.action,
          success: false,
          loading: false,
          message: 'failed'
        }
      };

    case FETCH_DRAFT_INSPECTION.pending: {
      return {
        ...state,
        fetchDraftInspectionAction: actionForState(state.action, 'pending')
      };
    }

    case FETCH_DRAFT_INSPECTION.success: {
      return {
        ...state,
        draftdata: {
          ...action.payload,
          remarks: action.payload.remarks
        },
        fetchDraftInspectionAction: actionForState(state.action, 'success')
      };
    }
    case FETCH_DRAFT_INSPECTION.error:
      return {
        ...state,
        fetchDraftInspectionAction: actionForState(state.action, 'error')
      };

      case CREATE_INSPECTION_ANSWER.success:
        return {
          ...state,
          answerCreated: action.payload,
          createAction: { loading: false, success: true, error: false }
        };
      case CREATE_INSPECTION_ANSWER.error:
        return {
          ...state,
          createAction: {
            ...state.action,
            success: false,
            loading: false,
            error: true
          }
        };
      case CREATE_INSPECTION_ANSWER.pending: {
        return {
          ...state,
          createAction: {
            success: false,
            loading: true,
            error: false
          }
        };
      }

    case CREATE_DRAFT_INSPECTION_ANSWER.success:
      return {
        ...state,
        draft_answer: action.payload,
        draftAction: actionForState(state.action, 'success')
      };
    case CREATE_DRAFT_INSPECTION_ANSWER.error:
      return {
        ...state,
        draftAction: actionForState(state.action, 'error')
      };
    case CREATE_DRAFT_INSPECTION_ANSWER.pending:
      return {
        ...state,
        draftAction: actionForState(state.action, 'pending')
      };

    case FETCH_DATA_SOURCE_VALUES.success:
      return {
        ...state,
        dataSourceValues: {
          ...state.dataSourceValues,
          [action.id]: action.payload
        },
        action: actionForState(state.action, 'success'),
        dataSourceAction: actionForState(state.action, 'success'),
        dataSourceCountAction: {
          ...state.dataSourceCountAction,
          [action.id]: actionForState(state.action, 'success')
        }
      };
    case FETCH_DATA_SOURCE_VALUES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error'),
        dataSourceAction: actionForState(state.action, 'error'),
        dataSourceCountAction: {
          ...state.dataSourceCountAction,
          [action.actionId]: actionForState(state.action, 'error')
        }
      };
    case FETCH_DATA_SOURCE_VALUES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending'),
        dataSourceAction: actionForState(state.action, 'pending'),
        dataSourceCountAction: {
          ...state.dataSourceCountAction,
          [action.actionId]: actionForState(state.action, 'pending')
        }
      };


    case FETCH_DATA_SOURCES.success:
      return {
        ...state,
        allDataSources: action.payload,
        action: actionForState(state.action, 'success')
      };
    case FETCH_DATA_SOURCES.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
    case FETCH_DATA_SOURCES.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };

    case FETCH_OPEN_WORKORDERS.success:
      return {
        ...state,
        OpenWorkOrders: action.payload,
        OpenWorkOrdersAction: actionForState(state.action, 'success')
      };

    case FETCH_INSPECTION_ANSWER_LIST.success:
      return {
        ...state,
        inspection_list: actionForState(state.action, 'success'),
        answers: action.payload
      };
    case FETCH_CHECKLIST_ATTACHMENTS.success:
      return {
        ...state,
        checklistAttachments: action.payload
      };
    case FETCH_INSPECTION_ANSWER_LIST.pending:
      return {
        ...state,
        inspection_list: actionForState(state.action, 'pending')
      };
    case FETCH_INSPECTION_ANSWER_LIST.error:
      return {
        ...state,
        inspection_list: actionForState(state.action, 'failed')
      };

      case FETCH_INSPECTION_ANSWER.success: {
        let theremarks = [];
        theremarks = action.payload.remarks;
        const theresponse = action.payload.response;
        const tolerance_result = theresponse?.tolerance_result || {};
        delete theresponse.tolerance_result;
        let workorders_count = 0;
        action.payload.version.schema.fields.forEach((item) => {
          if (item.type === 'inspection' && action.payload.response[item.id]) {
            Object.keys(action.payload.response[item.id]).forEach((key) => {
              let wo = [];
              if (action.payload.open_workorders) {
                wo = action.payload.open_workorders.filter(
                  e => item.id === e.category_id && key === e.subcategory_id
                );
                if (wo?.length > 0) workorders_count += wo?.length;
              }
              if (!theresponse[item.id][key]) {
                let nwo = [];
                if (action.payload.maintenance_workorders) {
                  nwo = action.payload.maintenance_workorders.filter(
                    e => item.id === e.category_id && key === e.subcategory_id
                  );
                }
                const itemRemarks = theremarks.filter(
                  e => item.id === e.field_reference && key === e.item_reference
                );
                if (
                  nwo.length === 0
                  && wo.length === 0
                  && itemRemarks === 0
                ) {
                  theresponse[item.id][key] = true;
                }
                if (
                  nwo.length === 0
                  || wo.length > 0
                  || itemRemarks > 0
                ) {
                  theresponse[item.id][key] = false;
                }
              }
            });
          }
        });
        return {
          ...state,
          answer: {
            ...state.answer,
            [action.id]: {
              ...action.payload,
              response: theresponse,
              remarks: theremarks,
              workorders_count,
              tolerance_result
            }
          },
          fetchInspectionAnswerAction: {
            loading: false,
            success: true,
            error: false
          }
        };
      }
      case FETCH_INSPECTION_ANSWER.pending:
        return {
          ...state,
          fetchInspectionAnswerAction: {
            loading: true,
            success: false,
            error: false
          }
        };
      case FETCH_INSPECTION_ANSWER.error:
        return {
          ...state,
          fetchInspectionAnswerAction: {
            loading: false,
            success: false,
            error: true
          }
        };
        case CLEAR_INSPECTION_ANSWER:
          return {
            ...state,
            answer: {
              version: {},
              response: {}
            },
            answerCreated: {},
            fetchInspectionAnswerAction: {
              success: false,
              pending: false,
              loading: false
            },
            remarkCreated: {}
          };

    case CLEAR_OPEN_WORKORDERS:
      return {
        ...state,
        OpenWorkOrders: {},
        OpenWorkOrdersAction: ''
      };
    case CLEAR_ACTION_RESULT:
      return {
        ...state,
        action: {},
        templateAction: {},
        fetchInspectionAction: {}
      };
    case CLEAR_ACTION_DATA_SOURCE:
      return {
        ...state,
        dataSourceValues: {}
      };
    case SEARCH_USER.success:
      return {
        ...state,
        userlist: action.payload
      };

    case CREATE_REMARK.success: {
      let allRemarks = [];
      if (state.answer[action.payload.answer]) {
        allRemarks = state.answer[action.payload.answer].remarks;
      } else if (state.draftdata.remarks) {
        allRemarks = state.draftdata.remarks;
      }

      const r = action.payload;
      if (r) {
        const existRemark = allRemarks.filter(rem => (
          rem?.id !== r?.id
        ));
        allRemarks = [
          ...existRemark,
          { ...r }
        ];
      }
      if (state.answer.id) {
        return {
          ...state,
          answer: {
            ...state.answer,
            remarks: allRemarks
          },
          fetchRemarksAction: {
            loading: false,
            success: true,
            error: false
          }
        };
      }
      return {
        ...state,
        draftdata: {
          ...state.draftdata,
          remarks: allRemarks
        },
        fetchRemarksAction: {
          loading: false,
          success: true,
          error: false
        },
        remarkCreated: action.payload
      };
    }
    case CREATE_REMARK.pending: {
      return {
        ...state,
        fetchRemarksAction: {
          loading: true,
          success: false,
          error: false
        }
      };
    }
    case CREATE_REMARK.error: {
      return {
        ...state,
        fetchRemarksAction: {
          loading: false,
          success: false,
          error: true
        }
      };
    }

    case REMOVE_REMARK: {
      let allRemarks = state.draftdata.remarks;
      allRemarks = allRemarks?.filter(rem => (
        rem?.id !== action?.remarkId
      ));
      return {
        ...state,
        draftdata: {
          ...state.draftdata,
          remarks: allRemarks
        }
      };
    }

    case DELETE_REMARK.success: {
      let allRemarks = [];
      if (state.answer[action?.aid]) {
        allRemarks = state.answer[action.aid].remarks;
      } else {
        allRemarks = state.draftdata.remarks;
      }

      allRemarks = allRemarks?.filter(rem => (
        rem?.id !== action?.remarkId
      ));

      if (state.answer[action?.aid]) {
        return {
          ...state,
          answer: {
            ...state.answer,
            [action.aid]: {
              ...state.answer[action.aid],
              remarks: allRemarks
            }
          }
        };
      }
      return {
        ...state,
        draftdata: {
          ...state.draftdata,
          remarks: allRemarks
        }
      };
    }

    case FETCH_SAFETY_SELF_INSPECTION.pending:
      return {
        ...state,
        action: actionForState('loading')
      };

    case FETCH_SAFETY_SELF_INSPECTION.success: {
      if (!action.payload.form) return state;
      const filtered = action.payload.form.schema.fields.filter(e => e.type === 'inspection');
      const insp =[];
      filtered.forEach((e) => {
        insp[e.id]= {
          title: e.title,
          checklist: e.checklist.map(el => ({ key: el.key, value: el.value })) };
      });
      return {
        ...state,
        selfInspection: insp,
        action: actionForState(action, 'success', 'success')
      };
    }
    case FETCH_TEMPLATES.success:
      return {
        ...state,
        templateList: action.payload,
        action: actionForState(action, 'success', 'success')
      };
    case FETCH_TEMPLATES.error:
      return {
        ...state,
        action: {
          ...state.action,
          success: false,
          loading: false,
          message: 'failed'
        }
      };
    case FETCH_TEMPLATE.success: {
      const { sections } = action.payload.schema;

      const detailFields = sections[0].fields.map(
        f => action.payload.schema.fields.find(fi => fi.id === f)
      ).map((f, i) => ({ ...f, order: i, template: true }));

      const checklistFields = sections[1].fields.map(
        f => action.payload.schema.fields.find(fi => fi.id === f)
      ).map((f, i) => ({ ...f, order: i, template: true }));

      return {
        ...state,
        template: {
          id: action.payload.id,
          new_version_available: action.payload.new_version_available,
          selected_version_id: action.payload.selected_version_id,
          info: {
            title: action.payload.title,
            icon: 'icon-1'
          },
          details: {
            fields: [...detailFields],
            additionalInfo: action.payload.additionalInfo
          },
          checklist: [...checklistFields]
        },
        templateAction: actionForState(action, 'success', 'success')
      };
    }
    case FETCH_TEMPLATE.error:
      return {
        ...state,
        action: {
          ...state.action,
          success: false,
          loading: false,
          message: 'failed'
        }
      };
    case HANGAR_INSPECTION_ANSWERS_LIST.pending:
      return {
        ...state,
        hangarAnswerListAction: actionForState(state.action, 'pending')
      };
    case HANGAR_INSPECTION_ANSWERS_LIST.success: {
      return {
        ...state,
        hangarAnswerList: action.payload,
        hangarAnswerListAction: actionForState(state.action, 'success')
      };
    }
    case HANGAR_INSPECTION_ANSWERS_LIST.error:
      return {
        ...state,
        hangarAnswerListAction: actionForState(state.action, 'error')
      };
    default:
      return state;
  }
}
